export default {
  env: 'production',
  sentryDsn:
    'https://646257b3d85e400385fe52afc5889a5e@o933210.ingest.sentry.io/5883989'
}
